import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    apiConfigApiNameOptions: [],
    apiConfigOtpValidityOptions: [],
    apiConfigAttributeNameOptions: [],
    apiConfigApiTypeOptions: [],
    apiConfigData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getApiConfigValues = createAsyncThunk(
    "api configuration management/api configuration dropdown values",
    async (user) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getLookupValues;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.get(apiURL);
            return response?.data?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

export const getApiConfigList = createAsyncThunk(
    "api configuration management/api configuration list",
    async ({ user, pagination, orderBy, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getApiConfigList;

            const apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;

            const response = await axiosInstance.post(apiURL, search);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddUpdateApiConfiguration = createAsyncThunk(
    "api configuration management/add update api configuration",
    async ({ user, body, update }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveMakerApiConfig;

            const apiURL = base + endpointpath;

            // const method = update ? 'put' : 'post';
            // const response = await axiosInstance[method](apiURL, body);
            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400' || response?.data?.responseCode === '403') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postRemoveMccBlock = createAsyncThunk(
    "mcc block management/remove mcc block",
    async ({ user, body }) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.saveMakerBlockedMcc;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.post(apiURL, body);

            if (response?.data?.responseCode === '400') {
                toast.error(response?.data?.responseDescription);
                return { status: response?.data?.responseCode };
            }

            toast.success('Request has been initiated and sent to checker');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const apiConfigSlice = createSlice({
    name: "apiConfig",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET API CONFIG VALUES
            .addCase(getApiConfigValues.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.apiConfigApiNameOptions = [];
                state.apiConfigOtpValidityOptions = [];
                state.apiConfigAttributeNameOptions = [];
                state.apiConfigApiTypeOptions = [];
            })
            .addCase(getApiConfigValues.fulfilled, (state, action) => {
                state.loading = false;
                state.apiConfigApiNameOptions = action?.payload?.apiName || [];
                state.apiConfigOtpValidityOptions = action?.payload?.otpValidity || [];
                state.apiConfigAttributeNameOptions = action?.payload?.attributeName ? action?.payload?.attributeName.map((value) => ({ label: value, value })) : [];
                state.apiConfigApiTypeOptions = action?.payload?.apiType ? action?.payload?.apiType.map((value) => ({ label: value, value })) : [];
            })
            .addCase(getApiConfigValues.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // GET API CONFIG LIST
            .addCase(getApiConfigList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.apiConfigData = [];
            })
            .addCase(getApiConfigList.fulfilled, (state, action) => {
                state.loading = false;
                state.apiConfigData = action?.payload?.resp || action?.payload?.data || [];               
                state.pagination = {
                    totalItem: action?.payload?.totalItem || 0,
                    currentPage: action?.payload?.currentPage || 0,
                    pageSize: action?.payload?.pageSize || 20,
                    totalPages: action?.payload?.totalPages || 0,
                };
            })
            .addCase(getApiConfigList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD UPDATE MCC BLOCK
            .addCase(postAddUpdateApiConfiguration.pending, (state) => {
                state.error = null;
            })
            .addCase(postAddUpdateApiConfiguration.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddUpdateApiConfiguration.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // REMOVE MCC BLOCK
            .addCase(postRemoveMccBlock.pending, (state) => {
                state.error = null;
            })
            .addCase(postRemoveMccBlock.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postRemoveMccBlock.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default apiConfigSlice.reducer;